<template>
    <div
        class="evaluate-settings apprentice-simple-card"
        v-if="evaluateIn.evaluate">
        <div class="evaluate-header">
            <div class="evaluate-per-assignment">
                <div class="component-title">
                    <h5 class="title">{{ $t('assignment.check') }}: {{ usersIn }}</h5>
                    <b-button
                        class="btn-per-assignment"
                        v-if="evaluateIn.type === '1'"
                        variant="primary"
                        @click="evaluateSelectAssignment()">
                        {{ $t('assignment.check_student') }}
                    </b-button>
                    <b-button
                        class="btn-per-student"
                        v-else
                        variant="primary"
                        @click="evaluateSelectUser()">
                        {{ $t('assignment.check_student') }}
                    </b-button>
                </div>
                <div
                    class="notification"
                    v-if="evaluateIn.type === '1'">
                    <b-alert
                        v-if="nextAssignments.length - 1 === 1"
                        variant="warning"
                        show>
                        Nog
                        <span class="label">{{ nextAssignments.length - 1 }} {{ $t('assignment.assignment') }}</span>
                        {{ $t('assignment.check_this_student') }}
                    </b-alert>
                    <b-alert
                        v-else-if="nextAssignments.length - 1 > 0"
                        variant="warning"
                        show>
                        Nog <span>{{ nextAssignments.length - 1 }} {{ $t('assignment.assignment') }}</span>
                        {{ $t('assignment.check_this_student') }}
                    </b-alert>
                    <b-alert
                        v-else
                        variant="warning"
                        show
                        >{{ $t('assignment.this_is_the_last_assignment_for_this_student') }}</b-alert
                    >
                </div>

                <div
                    class="notification"
                    v-else>
                    <b-alert
                        v-if="nextAssignments.length - 1 === 1"
                        variant="warning"
                        show>
                        Nog
                        <span class="label">{{ nextAssignments.length - 1 }} {{ $t('assignment.assignment') }}</span>
                        {{ $t('assignment.this_is_the_last_assignment_for_this_student') }}
                    </b-alert>
                    <b-alert
                        v-else-if="nextAssignments.length - 1 > 0"
                        variant="warning"
                        show>
                        Nog <span>{{ nextAssignments.length - 1 }} {{ $t('assignment.assignment') }}</span>
                        {{ $t('assignment.check_this_student') }}
                    </b-alert>
                    <b-alert
                        v-else
                        variant="warning"
                        show
                        >{{ $t('assignment.this_is_the_last_assignment_for_this_student') }}</b-alert
                    >
                </div>
            </div>

            <div class="evaluate-navigation">
                <div
                    class="navigation-per-student"
                    v-if="evaluateIn.type === '1'">
                    <b-button
                        class="btn-user-switch btn-change-user"
                        variant="primary"
                        @click="evaluateSelectUser()"
                        :disabled="lastUser">
                        {{ $t('assignment.choose_other_students') }}
                    </b-button>

                    <b-button
                        class="btn-after-chevron-right btn-next-student"
                        variant="primary"
                        @click="evaluateNextUser()">
                        {{ $t('common.next') }}
                    </b-button>
                </div>

                <div
                    class="navigation-per-assignment"
                    v-else>
                    <b-button
                        class="btn-change-assignment"
                        variant="primary"
                        @click="evaluateSelectAssignment()"
                        :disabled="lastAssignment">
                        {{ $t('assignment.choose_other_assignment') }}
                    </b-button>
                    <b-button
                        class="btn-after-chevron-right btn-next-assignment"
                        variant="primary"
                        @click="evaluateNextAssignment()">
                        {{ $t('assignment.choose_other_assignment') }}
                    </b-button>
                </div>
            </div>
        </div>
        <design-2021-assignment-edit-evaluate-next-assignment-modal-component
            :evaluate-in="evaluateIn"
            :assignment-id="assignmentIn.id"
            ref="evaluate-assignment-modal">
        </design-2021-assignment-edit-evaluate-next-assignment-modal-component>
        <design-2021-assignment-edit-evaluate-next-user-modal-component
            :evaluate="evaluateIn"
            ref="evaluate-user-modal">
        </design-2021-assignment-edit-evaluate-next-user-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-evaluate-modal',
    props: ['evaluateIn', 'usersIn', 'assignmentIn', 'projectId'],
    data() {
        return {
            evaluate_next_assignment_id: this.evaluateIn.next_assignment_id,
            evaluate_next_project_id: this.evaluateIn.next_project_id,
            next_assignment_pristine: true,
        };
    },
    computed: {
        nextProjects() {
            if (!this.evaluateIn_next_assignment_id) {
                return [];
            }
            for (const assignment of this.evaluateIn.lists.assignments) {
                if (assignment.id !== this.evaluateIn_next_assignment_id) {
                    continue;
                }
                return assignment.projects;
            }
            return [];
        },
        nextAssignments() {
            for (const user of this.evaluateIn.lists.users) {
                for (const project of user.projects) {
                    if (this.projectId === project.id) {
                        return project.assignments;
                    }
                }
            }
            return [];
        },
        lastUser() {
            return !this.evaluateIn.lists.users.length || this.evaluateIn.lists.users.length === 1;
        },
        lastAssignment() {
            return !this.evaluateIn.lists.assignments.length || this.evaluateIn.lists.assignments.length === 1;
        },
    },
    methods: {
        evaluateNextUser() {
            if (this.evaluateIn.one_left || !this.evaluateIn.next_assignment_id) {
                this.alert.notice(this.$t('assignment.checked_all'), this.$t('assignment.checked_all_assignments'));
            } else if (this.evaluateIn.next_user) {
                this.$refs['evaluate-user-modal'].show();
            } else {
                window.location.href =
                    this.routes.assignmentShow(this.evaluateIn.next_assignment_id, this.evaluateIn.next_project_id) +
                    '?evaluate=1&evaluate_type=1&evaluate_user=' +
                    this.evaluateIn.next_user_id;
            }
        },
        evaluateNextAssignment() {
            if (this.evaluateIn.one_left || !this.evaluateIn.next_assignment_id) {
                this.alert.notice(this.$t('assignment.checked_all'), this.$t('assignment.checked_all_assignments'));
            } else if (this.evaluateIn.next_assignment) {
                this.$refs['evaluate-assignment-modal'].show();
            } else {
                window.location.href =
                    this.routes.assignmentShow(this.evaluateIn.next_assignment_id, this.evaluateIn.next_project_id) +
                    '?evaluate=1&evaluate_type=2';
            }
        },
        evaluateSelectUser() {
            this.$refs['evaluate-user-modal'].show(true, true);
        },
        evaluateSelectAssignment() {
            this.$refs['evaluate-assignment-modal'].show(true, true);
        },
    },
};
</script>

<style scoped lang="scss">
.evaluate-settings {
    .component-title {
        justify-content: flex-start;
        flex-direction: column;

        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            align-self: flex-start;

            + .btn {
                margin-right: 0;
            }
        }
    }
}

.notification {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .alert {
        margin-bottom: 0;
    }
}

.navigation-per-student,
.navigation-per-assignment {
    display: flex;
    flex-direction: column;

    .btn {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .evaluate-settings {
        .component-title {
            flex-direction: row;

            .title {
                align-self: center;
                width: 100%;
                margin-bottom: 0;
            }
        }
    }

    .evaluate-per-assignment {
        .title {
            max-width: calc(100% - 211px);
        }
    }

    .evaluate-per-student {
        .title {
            max-width: calc(100% - 195px);
        }
    }

    .navigation-per-student,
    .navigation-per-assignment {
        flex-direction: row;
        justify-content: space-between;

        .btn {
            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }
}
</style>
